package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.{SubjectSessionsRequestData, IdentityData}
import com.neurobs.js.controller.AdminPanelController
import com.neurobs.ccabserver.subjectsessionview.Main
import com.neurobs.js.dom.ElementFactory
import com.neurobs.js.dom.ElementFactory.PanelView
import com.neurobs.js.view.{Container, Gui}
import org.scalajs.dom.raw.Event
import scalatags.JsDom.all._
import com.neurobs.js.dom.DOMViewElement._
import com.neurobs.util.{Guid, PrintLogger}

class SubjectSessionController2(gui: Gui, requestData: SubjectSessionsRequestData, userData: IdentityData, defaultSessionId: Option[Long] = None, defaultTestRunId: Option[Long] = None, titleName: String, addPanel: AdminPanelController => Unit, tags: ExaminerTagList) extends AdminPanelController {

	private val reactDiv = div().render

  private val panel: PanelView = {
    val temp = new PanelView(title = s"Sessions for $titleName", showRefresh = false, fullWidth = true)

    val closeButton = ElementFactory.makeLink(text = "Close")
    closeButton.onclick =  (_:Event) => delegate.foreach(_.close())
    temp.setRightCorner(closeButton)
    temp.container.addChild(reactDiv)
    temp
  }

  def openSessionLogPanel = (subjectGuid: Guid, sessionId: Long) => {
    addPanel(new SessionLogController(gui, new PrintLogger(printDebug = false), subjectGuid, sessionId, tags = tags))
  }

  override def didAppear(): Unit = {
    new Main(reactDiv, requestData, userData, openSessionLogPanel, defaultSessionId = defaultSessionId, defaultTestRunId = defaultTestRunId)
  }

  override def container: Container = {
    panel.container
  }
}
